<template>
  <div class="step">
    <h2>Privacy e consensi</h2>
    <p class="subtitle text-medium">
      Informative sul trattamento dei dati personali
    </p>
    <div class="fieldset">
      <p class="text-medium">
        Registrandomi dichiaro di aver preso visione dell'<a
          href="https://www.sace.it/docs/default-source/privacy/informativa-privacy-unica-ita-01-2021-sito-web_senza-firme.pdf"
          target="_blank"
        >informativa</a> fornita ai
        sensi di cui all'art. 13 e 14 del Regolamento Europeo 2016/679 - GDPR in
        materia di privacy ricevuta da SACE S.p.A. e dalle Società del perimetro
        nella qualità di Titolari e/o Contitolari del trattamento dei dati ai
        sensi dell’art. 26 del predetto GDPR. Il trattamento dei dati personali
        per le finalità di marketing è effettuato esclusivamente previo espresso
        consenso dell'interessato.
      </p>
      <p class="text-medium">
        Per quanto riguarda il trattamento dei propri dati personali
        relativamente all’attività di marketing (invio di materiale
        pubblicitario, vendita diretta, compimento di ricerche di mercato e
        comunicazione commerciale) e rilevazione di qualità anche attraverso
        tecniche di comunicazioni a distanza automatizzate (come email, sms,
        instant messaging) e tradizionali (come chiamate tramite operatore)
        della SACE e delle società del perimetro.
      </p>
      <div class="input-wrapper inline">
        <div class="radiobutton-field">
          <input
            id="consensoCommercialeTrue"
            v-model="params.commerciale"
            type="radio"
            name="consensoCommerciale"
            value="s"
            tabindex="1"
          >
          <label
            for="consensoCommercialeTrue"
            class="text-medium"
          >
            Presto il consenso
          </label>
        </div>
        <div class="radiobutton-field">
          <input
            id="consensoCommercialeFalse"
            v-model="params.commerciale"
            type="radio"
            name="consensoCommerciale"
            value="n"
          >
          <label
            for="consensoCommercialeFalse"
            class="text-medium"
          >
            Nego il consenso
          </label>
        </div>
      </div>
      <p class="text-medium">
        Per quanto riguarda la comunicazione dei suoi dati personali a terzi a
        fini di informazione commerciale, indagini statistiche, ricerche di
        mercato, offerte dirette di loro prodotti e servizi effettuate
        attraverso modalità tradizionali di contatto e attraverso modalità
        automatizzate di contatto.
      </p>
      <div class="input-wrapper inline">
        <div class="radiobutton-field">
          <input
            id="consensoGruppoTrue"
            v-model="params.gruppo"
            type="radio"
            name="consensoGruppo"
            value="s"
            tabindex="2"
          >
          <label
            for="consensoGruppoTrue"
            class="text-medium"
          >
            Presto il consenso
          </label>
        </div>
        <div class="radiobutton-field">
          <input
            id="consensoGruppoFalse"
            v-model="params.gruppo"
            type="radio"
            name="consensoGruppo"
            value="n"
          >
          <label
            for="consensoGruppoFalse"
            class="text-medium"
          >
            Nego il consenso
          </label>
        </div>
      </div>
      <p class="text-medium">
        Il consenso prestato potrà essere in ogni momento revocato scrivendo al
        seguente indirizzo di posta elettronica
        <a
          href="mailto:privacy@sace.it"
          target="_blank"
        >privacy@sace.it</a>.
      </p>
    </div>
    <div class="recaptcha-container">
      <input
        id="recaptcha"
        v-model="params.recaptchaToken"
        type="hidden"
        name="recaptcha"
      >
      <VueRecaptcha
        :sitekey="recapSitekey"
        @verify="markRecaptchaAsVerified"
        @expired="onExpiredRecaptcha"
      />
    </div>
    <div class="actions">
      <button
        class="button primary"
        :disabled="disabled"
        @click="!disabled ? submit() : null"
      >
        Avanti
      </button>
      <button
        class="back"
        @click="navigate('prev')"
      >
        Torna indietro
      </button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VueLodash from 'vue-lodash';
import lodash from 'lodash';
import VueRecaptcha from 'vue-recaptcha';

Vue.use(VueLodash, { lodash });

const _ = require('lodash');

export default {
  name: 'Privacy',
  components: { VueRecaptcha },
  props: {
    recapSitekey: '',
    preset: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      params: {
        commerciale: null,
        gruppo: null,
        recaptchaVerified: false,
        recaptchaToken: '',
      },
    };
  },
  computed: {
    disabled() {
      const { commerciale, gruppo, recaptchaVerified } = this.params;
      return commerciale === null || gruppo === null || recaptchaVerified == false;
    },
  },
  watch: {
    preset: {
      handler(v) {
        if (!_.isEmpty(v)) {
          this.params = v;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.$emit('push-event');
  },
  methods: {
    onExpiredRecaptcha() {
      this.params.recaptchaVerified = false;
      this.params.recaptchaToken = '';
    },
    markRecaptchaAsVerified(recaptchaToken) {
      this.params.recaptchaVerified = true;
      this.params.recaptchaToken = recaptchaToken;
    },
    navigate(step) {
      const obj = {
        params: this.params,
        step: 'privacy',
        navigate: step,
      };
      this.$emit('navigate', obj);
    },
    submit() {
      const obj = {
        params: this.params,
        step: 'privacy',
      };
      this.$emit('submit', obj);
    },
  },
};
</script>
